var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"faq-wrapper"},[_c('page-header',{attrs:{"text":"faq","font":"white","back":"black"}}),_c('b-container',[(_vm.i18n.locale === 'en')?_c('f-eu'):_vm._e(),(_vm.i18n.locale === 'pl')?_c('f-pl'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }